import React, { Component } from "react";
import { injectIntl } from "react-intl";
import AcknowledgementLayout from "../../../../Containers/common/acknowledgement";
import CloseIcon from "../../../../Assets/images/close.svg";
import {SecondaryButton} from "../../../Common/button";
import UploadAttachments from "../../../../Containers/AdminConsole/common/uploadAttachment";
import messages from "./messages";
// import "./style.less";

class DeactivateOrActivatePublicAdmin extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  formatMessage = data => this.props.intl.formatMessage(data);

  uploadHandler = (data, type) => {
	if(type==="attachDocs"){
		this.setState({attachDocs: data})
   }
   };


   deleteUpload = (type) => {
   if(type==="attachDocs"){
	this.setState({attachDocs: []})
   }
   };

   update = async () => {
	const { deactivatePublicAdmin, activatePublicAdmin, data: { adminId, deactivate = true, fetchPublicAdminProfile, getBasicInfo } = {}, close } = this.props;

	if(deactivate) {
	const response = await deactivatePublicAdmin({publicAdministrationId: adminId, attachments: this.state.attachDocs});
	const {status} = response;
	if(status){
	    fetchPublicAdminProfile(adminId);
	    getBasicInfo();
	} else {
		const { payload: {error: {data = [], status = ""} = {}} = {}} = response;
		if(status === "BRANCH_CONTAINS_USERS" && data.length !== 0) {
			this.setState({errorData: data})
			return;
		}
	}
	} else {
	const response = await activatePublicAdmin({publicAdministrationId: adminId, attachments: this.state.attachDocs});
	const {status} = response;
	if(status){
	    fetchPublicAdminProfile(adminId);
	    getBasicInfo();
	}
	}
	this.setState({attachDocs: undefined})
	close();
   }
    
    showUI = () => {

	const {close, data: {deactivate = true} = {}} = this.props;
	
	return (
		<div>
		<div className="flex justify-content-end  mt30 mr40 ml40  clickable" onClick={close}>
		<img src={CloseIcon} alt="close modal" />
	    </div>

		{deactivate && this.state.errorData && <div className="flex columns align-items-center  medium fontsize22 mr20 ml20">
		{`${this.formatMessage(messages.unableToDeactivate)}\n`}
	    </div>}

		{deactivate && this.state.errorData && <div className="flex columns align-items-center  medium fontsize22 mr20 ml20">
		<ul>
			{this.state.errorData&&this.state.errorData.map(error=><li key={error}>{error}</li>)}
		</ul>
		</div>}

		<div className="flex justify-content-center">
		<UploadAttachments fieldType={"attachDocs"} placeHolder={this.formatMessage(messages.attachesDocsMandatory)}  width={"w60"} multiple={true} uploadHandler={this.uploadHandler} deleteUpload={this.deleteUpload} type={"async"} />
		</div>

		<div className="flex justify-content-center align-items-center mt20">
		<SecondaryButton
		text={deactivate ? this.formatMessage(messages.deactivate) : this.formatMessage(messages.activate)}
        width="wpx120"
	    marginLeft="ml20"
	    marginRight="mr20"
	    handleOnClick={this.update}
	    disabled={!this.state.attachDocs || (deactivate && this.state.errorData)}
		/>
		</div>

		{/* <div className="flex columns  align-items-center  medium fontsize22 mr20 ml20">
		Failed to deactivate !!!!!!
	    </div> */}
		</div>
	);
    }
    

    render() {
	const {show} = this.props;
	if(!show){
	    return null;
	}

    return (
	    <AcknowledgementLayout>
	    {this.showUI()}
	    </AcknowledgementLayout>
    );
  }
}

export default injectIntl(DeactivateOrActivatePublicAdmin);
